import { Box, Card, CardContent, CardHeader, Chip, Divider, Grid, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function PaymentCard({ order }) {
    const { t } = useTranslation()
    // "paymentMethod": "APPLE_PAY",
    // "currentStatus": "REQUESTED",
    // "moyasarInvoice": null,
    // "discountValue": 0,
    // "deliveryPrice": 0,
    // "orderAmount": 60,
    // "totalAmount": 60,
    // "totalToPay": 60,
    // "orderNumber": 1684961118,
    return (
        <Card>
            <CardHeader title={t("Payments")} />
            <Divider />
            <CardContent>
                <Grid container>
                    <Grid item xs>
                        <Box my={20} display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontWeight: "bold" }}>{t("Status")}</Typography>
                            <Chip size="small" color='primary' label={t(`ORDER_STATUS.${order?.currentStatus}`)} variant='outlined' />
                        </Box>
                        <Box my={20} display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontWeight: "bold" }}>{t("Order cost")}</Typography>
                            <Chip size="small" color='primary' label={t("MONEY", { money: order?.orderAmount })} variant='outlined' />
                        </Box>
                        <Box my={20} display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontWeight: "bold" }}>{t("Total")}</Typography>
                            <Chip size="small" color='primary' label={t("MONEY", { money: order?.totalAmount })} variant='outlined' />
                        </Box>
                        <Box my={20} display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontWeight: "bold" }}>{t("Required to be paid")}</Typography>
                            <Chip size="small" color='primary' label={t("MONEY", { money: order?.totalToPay })} variant='outlined' />
                        </Box>
                    </Grid>
                    <Box sx={{ mx: 20 }} />
                    <Grid item xs>
                        <Box my={20} display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontWeight: "bold" }}>{t("Payment method")}</Typography>
                            <Chip size="small" color='primary' label={t(`PAYMENT_METHOD.${order?.paymentMethod}`)} variant='outlined' />
                        </Box>
                        <Box my={20} display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontWeight: "bold" }}>{t("Delivery")}</Typography>
                            <Chip size="small" color='primary' label={t("MONEY", { money: order?.deliveryPrice })} variant='outlined' />
                        </Box>
                        <Box my={20} display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontWeight: "bold" }}>{t("Discount")}</Typography>
                            <Chip size="small" color='primary' label={t("MONEY", { money: order?.discountValue })} variant='outlined' />
                        </Box>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}
